module.exports = __webpack_public_path__ + "img/GreatNovels-position.75143f91.png";